module.exports = __webpack_public_path__ + "img/all-assets.5f7bda50.svg";